import { render, staticRenderFns } from "./ProductImageCreate.vue?vue&type=template&id=5a6dc6f0&"
import script from "./ProductImageCreate.vue?vue&type=script&lang=ts&"
export * from "./ProductImageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports